import './offersCard.css';
import { ReactComponent as LeftInActive } from '../../assets/home/trvto_leftInActive.svg';
import { ReactComponent as RightActive } from '../../assets/home/trvto_RightActive.svg';
import { ReactComponent as OfferTag } from '../../assets/icons/offer_tag.svg';
import { ReactComponent as TimmerIcon } from '../../assets/icons/trvto_timer_icon.svg';
import { getFormattedDateReverse } from '../../utils/date';

const OffersCard = ({ offersData, scrollLeft, scrollRight, handleOfferCardClick }) => {
    const { code, limit, endsAt } = offersData;

    return (
        <div className='offerCard'>
            <div className='carouselBtnWrapper'>
                <button className='carouselBtn' onClick={scrollLeft}>
                    <LeftInActive />
                </button>
                <button className='carouselBtn active' onClick={scrollRight}>
                    <RightActive />
                </button>
            </div>
            <div className='offerCardContent' onClick={handleOfferCardClick}>
                <div className='offerCardContentContainer'>
                    <div className='offerCardTextAndValidity'>
                        <div className='offer-card-button-container'>
                            <span className='titleText'>Trip</span>
                        </div>
                        <div className='offer-card-validityText'>
                            <TimmerIcon />
                            <span className='offer-card-validText'>
                                Validity: {`${getFormattedDateReverse(endsAt) ?? 'N/A'}`}
                            </span>
                        </div>
                    </div>
                    <div className='offer-card-saveUpToText'>
                        <span>Save up to ₹{limit}</span>
                    </div>
                </div>
                <div className='offer-card-couponCode-Container'>
                    <button className='offer-card-offerTag'>
                        <OfferTag width={18} height={18} />
                    </button>
                    <span>{code}</span>
                </div>
            </div>
        </div>
    );
};

export default OffersCard;
